import { MoreOutlined } from "@ant-design/icons";

const MoreIcon = ({ className, ...props }) => {
  return <MoreOutlined className={`text-xl dark:text-white ${className || ""}`} {...props} />;
};

export default MoreIcon;
